module.exports = __webpack_public_path__ + "img/9.9736f649.jpeg";